import type { ModuleMigrationDef } from "@kubdee/sdk";

/**
 * Sales module initial migration.
 *
 * Note: quotations and quotation_items tables are defined in the accounting
 * module schemas and created by the base Drizzle migration.
 * This migration is a placeholder for future sales-specific tables.
 */
export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `-- Sales module tables are currently in base (accounting) schema`,
};
